function logInfo(...args) {
	// eslint-disable-next-line no-console
	console.log('%cITR DEBUG:', 'font-size:12px; font-weight: bold;', ...args);
}

export default logInfo;
